export function limitParagraph(text, size) {
  if (text?.length > size) {
    let shortText = text.substring(0, size);
    // Check if last character is a space, and remove it if not
    if (shortText[shortText.length - 1] !== ' ') {
      shortText = shortText.substring(0, shortText.lastIndexOf(' '));
    }
    return shortText + '...';
  } else {
    return text;
  }
}

export function getFirstFourWords(text) {
  const words = text?.split(' ');
  if (words?.length <= 4) {
    return text;
  } else {
    return words?.slice(0, 4).join(' ') + '...';
  }
}

export function getFirstTwoWords(text) {
  const words = text?.split(' ');
  if (words?.length <= 2) {
    return text;
  } else {
    return words?.slice(0, 2).join(' ') + '...';
  }
}
export function capitalizeFirstLetter(sentence) {
  if (!sentence) return sentence;
  return sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase();
}

export const isStringNull = (String) => {
  if (String === null || String === undefined) {
    return true;
  }
  return false;
};

export const formatYearDisplay = (v) => {
  const s = v != null ? String(v).trim() : '';
  if (!s || s.toLowerCase() === 'unassigned' || s.startsWith('Year ')) return s;
  return `Year ${v}`;
};

/**
 * Ends a fragment so another sentence can follow it.
 *
 * Counts written to stand alone ("12 of 30 ready") carry no full stop, so
 * anything appended to them runs the two together.
 */
export function endWithFullStop(text) {
  if (!text) return text;
  return /[.!?]$/.test(text.trim()) ? text : `${text}.`;
}
